import { Component, computed, inject, input } from '@angular/core';
import { AbstractFormControl } from '../abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SensorMergeDto } from '@artemis-software/wr-api';
import { SensorUnitMetadataService } from '@services/sensor-unit-metadata.service';
import SensorUnitEnum = SensorMergeDto.SensorUnitEnum;

@Component({
  standalone: false,
  selector: 'wr-sensor-unit-select',
  templateUrl: './sensor-unit-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SensorUnitSelectComponent,
      multi: true,
    },
  ],
})
export class SensorUnitSelectComponent extends AbstractFormControl<SensorUnitEnum> {
  private readonly sensorUnitMetadataService = inject(SensorUnitMetadataService);

  // undefined = unrestricted (plain unit picker), null = restricted but no unit chosen yet (no options)
  readonly compatibleWith = input<SensorUnitEnum | null | undefined>(undefined);
  readonly showEmptyOption = input(false);
  readonly placeholder = input('Einheit auswählen');

  // nb-select can never display a nullish option as selected, so the empty option uses a sentinel value
  protected readonly emptyOption = 'EMPTY';

  readonly values = computed<SensorUnitEnum[]>(() => {
    const compatibleWith = this.compatibleWith();
    if (compatibleWith === null) {
      return [];
    }
    return this.sensorUnitMetadataService.unitsOfSameDimension(compatibleWith);
  });

  get selected(): SensorUnitEnum | string | undefined {
    return this.value ?? (this.showEmptyOption() ? this.emptyOption : undefined);
  }

  set selected(selected: SensorUnitEnum | string | undefined) {
    this.value = selected === this.emptyOption ? undefined : (selected as SensorUnitEnum | undefined);
  }
}
